// Generated by `bazel run i18n`. Do not edit by hand.
import en from "./en/i18n.json";

export default en;
